import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

const Task = ({ task, onDelete, onComplete, isCompleted }) => {
	const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
		id: task.task_id,
	});

	const style = {
		opacity: isDragging ? 0.8 : 1,
		transform: CSS.Translate.toString(transform),
		zIndex: isDragging ? 1000 : 'auto',
		position: isDragging ? 'fixed' : 'static',
		pointerEvents: isDragging ? 'none' : 'auto',
		width: isDragging ? '300px' : '100%',
	};

	const handleComplete = async () => {
		if (!isCompleted) {
			onComplete(task.task_id);
		}
	};

	return (
		<div style={style} className='bg-white p-2 mb-2 rounded shadow z-50 flex justify-between items-center'>
			<div {...listeners} {...attributes} ref={setNodeRef} key={task.task_id} className='flex-grow cursor-move'>
				<span>{task.task}</span>
			</div>
			<div className='flex-shrink-0 ml-2'>
				<button
					hidden={isCompleted}
					onClick={handleComplete}
					className='text-green-500 hover:text-green-700 mr-2'
					title='Complete Task'
				>
					✓
				</button>
				<button
					onClick={() => onDelete(task.task_id, 'grid')}
					className='text-red-500 hover:text-red-700'
					title='Delete Task'
				>
					×
				</button>
			</div>
		</div>
	);
};

export default Task;
